var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 15.4074C4.375 14.5698 4.375 14.151 4.48296 13.7653C4.57859 13.4237 4.73574 13.1023 4.94671 12.8171C5.18487 12.4951 5.51545 12.238 6.17661 11.7238L16.0675 4.03086C16.5798 3.63237 16.836 3.43312 17.1189 3.35653C17.3685 3.28895 17.6315 3.28895 17.8811 3.35653C18.164 3.43312 18.4202 3.63237 18.9325 4.03086L28.8234 11.7238C29.4846 12.238 29.8151 12.4951 30.0533 12.8171C30.2643 13.1023 30.4214 13.4237 30.517 13.7653C30.625 14.151 30.625 14.5698 30.625 15.4074V25.9583C30.625 27.5918 30.625 28.4086 30.3071 29.0325C30.0275 29.5813 29.5813 30.0275 29.0325 30.3071C28.4086 30.625 27.5918 30.625 25.9583 30.625H9.04167C7.40818 30.625 6.59144 30.625 5.96753 30.3071C5.41872 30.0275 4.97253 29.5813 4.6929 29.0325C4.375 28.4086 4.375 27.5918 4.375 25.9583V15.4074Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSvgrepoCom);
export default __webpack_public_path__ + "static/media/home-svgrepo-com.a48f99d6.svg";
export { ForwardRef as ReactComponent };